export const TACQ0004_EXPERIMENT_KEY = 'tacq-0004';